import React, { type FC } from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  getSmoothStepPath,
  type Edge,
  type EdgeProps,
} from "@xyflow/react";
import { MdClose } from "react-icons/md";
import CircleButton from "widgets/controls/buttons/circle-button";

type RemovableEdgeData = {
  onDelete?: (source: string, target: string) => void;
  color?: string;
};

const RemovableEdge: FC<EdgeProps<Edge<RemovableEdgeData>>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  selected,
  source,
  target,
  data,
}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 0,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          strokeWidth: selected ? 4 : 2,
          stroke: data?.color ? data?.color : "#888888",
        }}
      />
      {selected && data?.onDelete && (
        <EdgeLabelRenderer>
          <div
            className="nodrag nopan"
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: "all",
            }}
          >
            <CircleButton
              extra="z-50"
              icon={MdClose}
              size="xs"
              onClick={() => {
                data?.onDelete?.(source, target);
              }}
            />
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default RemovableEdge;
